import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { apiError } from "@/lib/http";
import { InstallBanner } from "@/components/shared/Install";
import PasskeyButton from "@/features/auth/PasskeyButton";
import { useWebAuthnSupport } from "@/hooks/usePasskey";

export default function LoginPage() {
  const { login, loginWithPasskey } = useAuth();
  const { platform: hasBio } = useWebAuthnSupport();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); nav("/"); }
    catch (err) { setError(apiError(err)); }
    finally { setBusy(false); }
  };

  const onPasskey = (data) => { loginWithPasskey(data); nav("/"); };

  return (
    <div className="min-h-dvh bg-[var(--cream)] flex flex-col">
      <div className="mx-auto w-full max-w-md px-6 pt-16 flex-1 flex flex-col">
        <p className="eyebrow rise">arquivo vivo da vida a dois</p>
        <h1 className="serif text-6xl leading-[0.95] text-[var(--coffee)] mt-3 rise rise-1">
          Nossa<br /><em className="font-light">Base</em>
        </h1>
        <p className="hand text-2xl text-[var(--coral)] mt-4 rise rise-2">a gente decide junto.</p>

        <form onSubmit={submit} className="mt-14 space-y-4 rise rise-3" data-testid="login-form">
          <label className="block">
            <span className="eyebrow block mb-2">e-mail</span>
            <input className="field" type="email" autoComplete="username webauthn" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
          </label>
          <label className="block">
            <span className="eyebrow block mb-2">senha</span>
            <input className="field" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
          </label>
          {error && <p className="text-sm text-[var(--coral)]" data-testid="login-error">{error}</p>}
          <button className="btn-primary w-full h-14 text-base mt-2" disabled={busy} data-testid="login-submit-button">
            {busy ? "entrando…" : "Entrar"}
          </button>
          <div className="flex items-center justify-between pt-2 text-sm">
            <Link to="/forgot-password" className="text-[var(--coffee-muted)] underline underline-offset-2" data-testid="login-to-forgot-link">
              esqueci minha senha
            </Link>
            <Link to="/register" className="text-[var(--coffee)] font-medium" data-testid="login-to-register-link">
              criar conta →
            </Link>
          </div>
        </form>

        {hasBio && (
          <>
            <div className="mt-6 flex items-center gap-3 rise rise-3">
              <span className="h-px flex-1 bg-[var(--line)]" />
              <span className="text-xs text-[var(--coffee-muted)] uppercase tracking-wider">ou</span>
              <span className="h-px flex-1 bg-[var(--line)]" />
            </div>
            <div className="mt-4 rise rise-4">
              <PasskeyButton email={email} onSuccess={onPasskey} />
            </div>
          </>
        )}

        <InstallBanner className="mt-8 rise rise-4" />
        <p className="text-xs text-[var(--coffee-muted)] mt-auto pb-10 pt-6 rise rise-4">
          14 dias grátis. Sem cartão pra começar.
        </p>
      </div>
    </div>
  );
}
